module.exports = __webpack_public_path__ + "img/blue-plus.svg";